import React from "react";
import "./Css/Docs.css";
import Navigation from "./Navigation";
import Footer from "./Footer";
const Docs = () => {
  const docsSection = () => {
    return (
      <div>
        <section className="docsSection">
          <div className="docssection-div">
            <h1 className="heading">Documentation</h1>
            <p className="docsDesc">
              Here you have detailed documentation of all available API
              endpoints.To get started, you can make the sample request for each
              endpoint, run the examples in Postman.
            </p>

            {/* Get All Aliens */}
            <h1 className="endpointHeading">Get All Aliens</h1>
            <p className="endpointDesc">
              Get all aliens data on single request.Returns a array of all
              ben-10 aliens.
            </p>
            <pre className="endpoint">
              <span className="method">GET</span>
              <code>https://ben-10-api.herokuapp.com/api/v1/aliens</code>
            </pre>
            <pre className="outputEndpoint">
              <h1 className="outputHeading">Example Request and Response</h1>
              <span className="method">GET</span>
              <code>https://ben-10-api.herokuapp.com/api/v1/aliens</code>
            </pre>

            {/* Search Alien */}
            <h1 className="endpointHeading">Search Alien</h1>
            <p className="endpointDesc">
              Search through all the aliens using advanced filtering of
              MongoDB.Note: You can only search the alien by its name.
            </p>
            <pre className="endpoint">
              <span className="method">GET</span>
              <code>
                https://ben-10-api.herokuapp.com/api/v1/alien/search/query=Alien
              </code>
            </pre>
            <pre className="outputEndpoint">
              <h1 className="outputHeading">Example Request and Response</h1>
              <span className="method">GET</span>
              <code>
                https://ben-10-api.herokuapp.com/api/v1/alien/search/query=heatblast
              </code>
            </pre>

            <pre className="outputBox">
              <code>
                {`[
    {
        "_id": "60d855ba6eb86963e4febb7f",
        "image": "https://static.wikia.nocookie.net/ben10/images/6/61/Standing_Heatblast.png/revision/latest/scale-to-width-down/364?cb=20201111073426",
        "imageCredits": "https://ben10.fandom.com/",
        "name": "Heatblast",
        "species": "Pyronite",
        "home_world": "Pyros",
        "body": "Fiery Humanoid",
        "powers": "Pyrokinesis,Heat Generation,Fire Breath,Fire Tornado Generation,Enhanced Strength,Enhanced Durability,Pyro Immunity,Cryo Immunity,Pyrokinetic Flight,Pyrokinetic Surfing,Enhanced Speed (via Pyrokinetic Flight),Pyro Laser,Underwater Survivability,Cartoon Physiology (temporarily)",
        "__v": 0
    }
]`}
              </code>
            </pre>

            {/* Get Random Alien  */}
            <h1 className="endpointHeading">Get Random Alien</h1>
            <p className="endpointDesc">
              Get random alien each time you send a request.Returns a single
              random alien on each request.
            </p>
            <pre className="endpoint">
              <span className="method">GET</span>
              <code>
                https://ben-10-api.herokuapp.com/api/v1/alien/random-alien
              </code>
            </pre>
            <pre className="outputEndpoint">
              <h1 className="outputHeading">Example Request and Response</h1>
              <span className="method">GET</span>
              <code>
                https://ben-10-api.herokuapp.com/api/v1/alien/random-alien
              </code>
            </pre>

            <pre className="outputBox">
              <code>
                {`{
  "_id": "60d856586eb86963e4febb81",
  "image": "https://static.wikia.nocookie.net/ben10/images/8/80/Xlr8_re.png/revision/latest/scale-to-width-down/620?cb=20160916224332",
  "imageCredits": "https://ben10.fandom.com/",
  "name": "XLR8",
  "species": "Kineceleran",
  "home_world": "Kinet",
  "body": "Humanoid Velociraptor",
  "powers": "Enhanced Speed,Enhanced Agility,Enhanced Stamina,Enhanced Jumping,Enhanced Reflexes,Enhanced Recovery,Enhanced Strength,Enhanced Dexterity,Enhanced Durability,Enhanced Directionality,Accelerated Thinking,Sharp Back Fins,Sharp Claws,Sharp Feet,Wall and Water Running,Wall Crawling,Prehensile Tail,Vortex Creation,Time Travel (with enough energy),Speed Mirage Creation",
  "__v": 0
}`}
              </code>
            </pre>

            {/* Get Alien By Id */}
            <h1 className="endpointHeading">Get Alien By Id</h1>
            <p className="endpointDesc">
              Get alien by providing an AlienId in query.
            </p>
            <pre className="endpoint">
              <span className="method">GET</span>
              <code>
                https://ben-10-api.herokuapp.com/api/v1/alien/id=AlienId
              </code>
            </pre>
            <pre className="outputEndpoint">
              <h1 className="outputHeading">Example Request and Response</h1>
              <span className="method">GET</span>
              <code>
                https://ben-10-api.herokuapp.com/api/v1/alien/id=60d83bc11cbb605df3eaab53
              </code>
            </pre>

            <pre className="outputBox">
              <code>
                {`{
  "_id": "60d83bc11cbb605df3eaab53",
  "image": "https://static.wikia.nocookie.net/ben10/images/e/e4/Cannonbolt_re.png/revision/latest/scale-to-width-down/619?cb=20190525182507",
  "imageCredits": "https://ben10.fandom.com/",
  "name": "Cannonbolt",
  "species": "Arburian Pelarota",
  "home_world": "Arburia",
  "body": "Panda-like Pillbug",
  "powers": "Enhanced Strength,Enhanced Durability,Enhanced Speed,Enhanced Balance,Enhanced Agility,Enhanced Jumping,Enhanced Bouncing,Enhanced Dexterity,Enhanced Reflexes,Enhanced Hearing,Sphere Transformation,Environmental Perception (via Spherical Form),Echolocation,Energy,Deflection,Sharp Claws,Sharp Teeth,Sharp Feet,Acid Immunity,Lava Immunity,Mobile Invulnerability",
  "__v": 0
}`}
              </code>
            </pre>
          </div>
        </section>
      </div>
    );
  };

  return (
    <div>
      <Navigation />
      {docsSection()}
      <Footer />
    </div>
  );
};

export default Docs;
